<script>
import { modalEvents } from '../../../utils/vue/modalHandler';

export default {
  name: 'modal-events',

  mounted() {
    modalEvents.$on(this.modalName, this.OnModalEvent);
  },
  beforeDestroy() {
    modalEvents.$off(this.modalName, this.OnModalEvent);
  },
  methods: {
    OnModalEvent({ type, data }) {
      this.$emit(type, data);
    },
  },
  props: {
    modalName: {
      type: String,
      required: true,
    },
  },
  render() {
    return this.$slots.default;
  },
};
</script>
